import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@springtree/eva-config-picker/loader';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://8681768056014d01a66ce12721b413f6@o321914.ingest.sentry.io/6137589",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracePropagationTargets: ["localhost"],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.log(err));

defineCustomElements(window);
